import { UPDATE_CVS } from "Redux/Actions/cvsActions.js";

const INITIAL_STATE = {
  cvsData: [],
  cvsDataFiltered: [],
  isCVsSearch: false,
  cvsBasket: [],
  addedResumeId: null,
  isAddedResume: false,
  visibleModalPanier: false,
  cvsBasketIsSearched: false,
  cvsBasketFiltered: [],
  isAddedFromBasket: false,
  fromBasketId: null,
};

const cvsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_CVS: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default cvsReducer;
